// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export let CreateMapByObject = function (obj)   
{
    let res = {}

    for (let prop in obj)
        res[obj[prop]] = prop

    return res
}

export let CreateMapByObj = function (obj)      // делает тоже что и CreateMapByObject но с использованием Object.keys и обычного цикла
{
    var res = {}
    var keys = Object.keys(obj)
    var keysLen = keys.length
    for (let i = 0; i < keysLen; i++)
        res[obj[keys[i]]] = keys[i]

    return res
}